import { ICompany } from '../../../../types/companies';
import { axiosInstance } from '../../../../../network/apis';

export function getAllCompanies({ params }: { params?: any }) {
  return axiosInstance.get<Array<ICompany>>(`/admin/company_deletion_requests`, {
    params,
  });
}
